import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VDialog,
    _vm._g(
      _vm._b(
        {
          attrs: {
            "data-qa": "core-dialog",
            width: _setup.DIALOG_WIDTHS[_vm.size],
            fullscreen: _setup.modalSizes.fullscreen,
          },
          model: {
            value: _setup.isOpened,
            callback: function ($$v) {
              _setup.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        "v-dialog",
        {
          ..._vm.$attrs,
          "content-class": _vm.$attrs["content-class"]
            ? `${_vm.$attrs["content-class"]} flex-dialog`
            : "flex-dialog",
        },
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "div",
        {
          staticClass:
            "core-dialog d-flex flex-column flex-grow-1 overflow-y-auto bg-gray-0 elevation-20 h-100 position-relative",
          class: {
            "core-dialog--sm": _setup.modalSizes.sm,
            "core-dialog--md": _setup.modalSizes.md,
            "core-dialog--fullscreen": _setup.modalSizes.fullscreen,
            "rounded-sm": !_setup.modalSizes.fullscreen,
          },
          style: {
            height: _setup.getSize(_vm.height),
            maxHeight: _setup.getSize(_vm.maxHeight),
            minHeight: _setup.getSize(_vm.minHeight),
          },
          attrs: { "data-qa": _vm.dataQa, "data-qa-base": "core-dialog" },
        },
        [
          _vm.title ||
          _vm.$slots.prependBtn ||
          _vm.$scopedSlots.prependBtn ||
          _vm.$slots.title ||
          _vm.$slots.appendBtn ||
          _vm.$slots.extension
            ? _c(
                "div",
                {
                  staticClass: "core-dialog__container flex-shrink-0",
                  attrs: { "data-qa": "core-dialog-toolbar-container" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "core-dialog__toolbar d-flex flex-column justify-center ga-2",
                      class: { "pb-0": !_vm.divider && _vm.$slots.default },
                      attrs: { "data-qa": "core-dialog-toolbar" },
                    },
                    [
                      _vm.title ||
                      _vm.$slots.prependBtn ||
                      _vm.$scopedSlots.prependBtn ||
                      _vm.$slots.title ||
                      _vm.$slots.appendBtn
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "core-dialog__header d-flex align-center text-break ga-9",
                            },
                            [
                              _vm._t("prependBtn", null, {
                                btnProps: _setup.PREPEND_BTN_PROPS,
                              }),
                              _vm._v(" "),
                              _vm.title || _vm.$slots.title
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center text-h6 text--text mr-auto",
                                      attrs: { "data-qa": "core-dialog-title" },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.title) +
                                          "\n            "
                                      ),
                                      _vm._t("title"),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("appendBtn"),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("extension"),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.divider
            ? _c(VDivider, { staticClass: "border-t-sm" })
            : _vm._e(),
          _vm._v(" "),
          _vm.$scopedSlots.default || _vm.$slots.default
            ? _c(
                "div",
                {
                  staticClass:
                    "core-dialog__container d-flex flex-column flex-fill overflow-y-auto custom-scroll",
                  attrs: { "data-qa": "core-dialog-content" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column flex-fill py-4",
                      class: [
                        _setup.modalSizes.fullscreen ? "px-4" : "px-6",
                        _vm.slotContentClass,
                      ],
                    },
                    [
                      _vm._t("default", null, {
                        xSpaceClass: _setup.modalSizes.fullscreen
                          ? "px-4"
                          : "px-6",
                        counterXSpaceClass: _setup.modalSizes.fullscreen
                          ? "mx-n4"
                          : "mx-n6",
                      }),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$slots.actions
            ? _c(
                "div",
                {
                  staticClass: "core-dialog__container flex-shrink-0 mt-auto",
                  class: {
                    "elevation-2": _setup.modalSizes.fullscreen,
                  },
                  attrs: { "data-qa": "core-dialog-actions-container" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "core-dialog__actions d-flex align-center justify-end",
                      class: {
                        "ga-2 pa-2":
                          _setup.modalSizes.sm ||
                          _setup.modalSizes.md ||
                          _setup.modalSizes.fullscreen,
                        "ga-4 pt-2 px-6 pb-6":
                          _setup.modalSizes.lg || _setup.modalSizes.xl,
                      },
                      attrs: { "data-qa": "core-dialog-actions" },
                    },
                    [_vm._t("actions")],
                    2
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }